export default __webpack_public_path__ + "static/media/understanding.ff429151.svg";